<ng-container *ngIf="{ selectBreadcrumbs: selectBreadcrumbs$ | async } as data">
  <div class="flex-row w-100 h-100 root-content-wrapper">
    @if (!viewportService.isMobile()) {
      <app-sidebar></app-sidebar>
    }
    <div class="w-100 flex-col main-content">
      @if (!viewportService.isMobile()) {
        <ui-header-with-breadcrumbs
          [selectBreadcrumbs]="data.selectBreadcrumbs || []"
        >
          @if (headerActionsTemplate()) {
            <ng-container
              [ngTemplateOutlet]="headerActionsTemplate()!"
            ></ng-container>
          }
          <div class="flex-row start-center gap-8 icon-16">
            @for (action of pageActions(); track $index) {
              @if (!action.hidden?.()) {
                @switch (action.type) {
                  @case ('refresh') {
                    <ui-refresh-button
                      [loading]="action.loading?.() ?? false"
                      (clicked)="action.handler()"
                    >
                    </ui-refresh-button>
                  }
                  @case ('primary') {
                    <ui-button
                      type="primary"
                      [text]="action.label | translate"
                      [disabled]="action.disabled?.() ?? false"
                      [loading]="action.loading?.() ?? false"
                      (clickAction)="action.handler()"
                    >
                    </ui-button>
                  }
                  @case ('secondary') {
                    <ui-button
                      type="secondary"
                      [text]="action.label | translate"
                      [disabled]="action.disabled?.() ?? false"
                      [loading]="action.loading?.() ?? false"
                      (clickAction)="action.handler()"
                    >
                    </ui-button>
                  }
                  @case ('default') {
                    <ui-button
                      type="default"
                      [text]="action.label | translate"
                      [loading]="action.loading?.() ?? false"
                      [disabled]="action.disabled?.() ?? false"
                      (clickAction)="action.handler()"
                    >
                    </ui-button>
                  }
                  @case ('noBorderPrimary') {
                    <ui-button
                      type="noBorderPrimary"
                      [text]="action.label | translate"
                      [loading]="action.loading?.() ?? false"
                      [disabled]="action.disabled?.() ?? false"
                      (clickAction)="action.handler()"
                    >
                    </ui-button>
                  }
                }
              }
            }
          </div>
        </ui-header-with-breadcrumbs>
      }
      <app-mobile-header-outlet></app-mobile-header-outlet>
      <div class="page-content flex">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <app-mobile-bottom-bar></app-mobile-bottom-bar>
</ng-container>
